import { CallHistoryProgressStateMemoChangedRealTimeData } from 'src/generated/signalR/call-history-progress-state-memo-changed-real-time-data';
import { CallHistoryProgressMemoInfoRemoteDto, CallHistoryResponseData } from '../../../../../../../generated/swagger';
import { CallProgressState } from '../../../../../../samwebDescription/samweb/callHistory/callProgressState';
import { LongRunningContextCategoryTyp } from '../../../../../../samwebDescription/samweb/waitingContext/waitingContextCategory';
import { ActionErrorDescription } from '../../../../../notification/notification-toastr/types/actionErrorDescription.decorator';
import { LongRunningAction } from '../../../../../server-communication/running-actions/types/longRunningAction.decorator';
import { IBrickInstanceTargetingAction } from '../../../../../utility/IBrickInstanceTargetingAction';

@LongRunningAction(LongRunningContextCategoryTyp.CALL_HISTORY)
@ActionErrorDescription({
   titleTranslationKey: 'brick.brick_definitions.call_history_browser.error_handling.loading_failed.title',
   messageTranslationKey: 'brick.brick_definitions.call_history_browser.error_handling.loading_failed.message',
})
export class CallHistoryLoadMoreEntries implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] load more entries';

   constructor(public brickInstanceId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.CALL_HISTORY)
export class CallHistoryChangeDataPage implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] change data page';

   constructor(public brickInstanceId: string, public skip: number, public take: number) {}
}

export class CallHistoryScrollTopChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] scroll top changed';

   constructor(public brickInstanceId: string, public scrollTop: number) {}
}

export class CallHistoryClearAndStartLoadingEntries implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] clear and start loading entries';

   constructor(public brickInstanceId: string) {}
}

export class CallHistoryMoreEntriesLoaded implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] more entries loaded';

   constructor(public brickInstanceId: string, public result: CallHistoryResponseData) {}
}

export class CallHistoryNewEntriesLoaded implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] new entries loaded';

   constructor(public brickInstanceId: string, public result: CallHistoryResponseData) {}
}

export class CallHistoryLoadNewestEntries implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] load newest entries';

   constructor(public brickInstanceId: string) {}
}

export class CallHistorySearchValueChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] search value changed';

   constructor(public brickInstanceId: string, public searchValue: string) {}
}

export class CallHistoryBrowserMakeCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] make call';

   constructor(public brickInstanceId: string) {}
}

export class CallHistoryFiltersChanged implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] filters changed';

   constructor(public brickInstanceId: string) {}
}

export class CallHistoryAllFilterCleared implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] all filter cleared';

   constructor(public brickInstanceId: string) {}
}

export class CallHistorySearchChangedThroughIncomingCall implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] search changed through incoming call';

   constructor(public brickInstanceId: string, public searchValue: string) {}
}

export class CallHistorySearchChangedThroughIncomingCallFinished implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] search changed through incoming call finished';

   constructor(public brickInstanceId: string) {}
}

@LongRunningAction(LongRunningContextCategoryTyp.CALL_HISTORY)
export class CallHistoryChangeProgressState {
   public static readonly type = '[Call History Browser Behaviour] change history progress state';

   constructor(public uniqueCallId: string, public progressState: CallProgressState, public originalAgentId?: number) {}
}

export class CallHistoryProgressStateMemoChangedByServer {
   public static readonly type = '[Call History Browser Behaviour] change history progress state / memo';

   constructor(public data: CallHistoryProgressStateMemoChangedRealTimeData) {}
}

export class CallHistoryEntrySelected implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] entry selected';

   constructor(public brickInstanceId: string, public uniqueCallId: string) {}
}

export class CallHistorySelectNextEntry implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] select next entry';

   constructor(public brickInstanceId: string, public direction: 'up' | 'down', public step = 1) {}
}

export class CallHistorySearchStarted implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] search started';

   constructor(public brickInstanceId: string) {}
}

export class CallHistorySearchEnded implements IBrickInstanceTargetingAction {
   public static readonly type = '[Call History Browser Behaviour] search ended';

   constructor(public brickInstanceId: string) {}
}

export class RemoveSpecifiedCallHistoryData {
   public static readonly type = '[Call History Browser Behaviour] Remove Specified Call History Data';

   public constructor(public brickInstanceId: string, public dataToRemove: CallHistoryProgressMemoInfoRemoteDto[]) {}
}
